import React from "react";
import {BASE_URL, validateEmail, hideAlertAfterDelay} from "../../helper";
import API from "../../api";
import "../../assets/css/notification.css";
import "../../assets/css/input.css";
import "../../assets/css/errors.css";
import Input from "react-phone-number-input/input";
import "react-phone-number-input/style.css";
import {Helmet} from "react-helmet";
import {images} from "../../constant";
import CommonStaticSidebar from "./commonStaticSidebar";

const api = new API();

class Testimonial extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Data: this.getInitialDataState(),
            errors: {},
            touched: this.getInitialTouchedState(),
            errorAlert: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEvenPhone = this.handleEvenPhone.bind(this);
        this.fullNameRef = React.createRef();
        this.phoneRef = React.createRef();
        this.emailRef = React.createRef();
        this.messageRef = React.createRef();
        this.alertBox = React.createRef();
    }

    getInitialDataState() {
        return {
            name: "",
            email: "",
            phone: "",
            message: "",
        };
    }

    getTestimonialFieldNames() {
        return ["message", "name", "email"];
    }

    getInitialTouchedState() {
        return this.getTestimonialFieldNames().reduce((touched, name) => {
            touched[name] = false;
            return touched;
        }, {});
    }

    getAllTouchedState() {
        return this.getTestimonialFieldNames().reduce((touched, name) => {
            touched[name] = true;
            return touched;
        }, {});
    }

    sanitizeFieldValue(name, value) {
        let updatedValue = value === null || value === undefined ? "" : value.toString();

        if (name === "name") {
            updatedValue = updatedValue
                .replace(/[^a-zA-Z\s]/g, "")
                .replace(/\s+/g, " ")
                .slice(0, 50);
        }

        return updatedValue;
    }

    // Testimonial validation is shared by blur, change-after-blur, and submit.
    getFieldValidationError(name, value) {
        const fieldValue = value === null || value === undefined ? "" : value.toString().trim();

        if (name === "message") {
            return !fieldValue ? "Enter message" : "";
        }

        if (name === "name") {
            return !fieldValue ? "Enter full name" : "";
        }

        if (name === "email") {
            return !fieldValue || !validateEmail(fieldValue) ? "Enter valid email address" : "";
        }

        return "";
    }

    getFormValidationErrors(data = this.state.Data) {
        const errors = {};

        this.getTestimonialFieldNames().forEach((name) => {
            const error = this.getFieldValidationError(name, data[name]);

            if (error) {
                errors[name] = error;
            }
        });

        return errors;
    }

    getUpdatedErrors(name, value, errors = this.state.errors) {
        const updatedErrors = {...errors};
        const fieldError = this.getFieldValidationError(name, value);

        if (fieldError) {
            updatedErrors[name] = fieldError;
        } else {
            delete updatedErrors[name];
        }

        return updatedErrors;
    }

    scrollToFirstError(errors) {
        const fieldRefs = {
            message: this.messageRef,
            name: this.fullNameRef,
            email: this.emailRef,
        };
        const firstErrorField = this.getTestimonialFieldNames().find((name) => errors[name]);

        if (firstErrorField && fieldRefs[firstErrorField] && fieldRefs[firstErrorField].current) {
            fieldRefs[firstErrorField].current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleChange(event) {
        const {name} = event.target;
        const value = this.sanitizeFieldValue(name, event.target.value);

        this.setState((prevState) => {
            const Data = {
                ...prevState.Data,
                [name]: value,
            };
            const shouldValidate = prevState.touched[name] || prevState.errors[name];

            return {
                Data,
                errors: shouldValidate
                    ? this.getUpdatedErrors(name, value, prevState.errors)
                    : prevState.errors,
                errorAlert: null,
            };
        });
    }

    handleBlur(event) {
        const {name} = event.target;
        const touched = {
            ...this.state.touched,
            [name]: true,
        };

        this.setState({
            touched,
            errors: this.getUpdatedErrors(name, this.state.Data[name]),
        });
    }

    handleEvenPhone(event) {
        this.setState((prevState) => ({
            Data: {
                ...prevState.Data,
                phone: event,
            },
            errorAlert: null,
        }));
    }

    handleSubmit(event) {
        this.setState({
            errorAlert: null,
        });
        event.preventDefault();

        const errors = this.getFormValidationErrors();

        if (Object.keys(errors).length > 0) {
            this.setState({
                errors,
                touched: this.getAllTouchedState(),
            });
            this.scrollToFirstError(errors);
            return false;
        }

        api.contactUs(this.state.Data)
            .then((success) => {
                this.setState({
                    errors: {},
                    touched: this.getInitialTouchedState(),
                    Data: this.getInitialDataState(),
                });
                this.setState({
                    errorAlert: "Your inquiry posted",
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });
            })
            .catch((error) => {
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : "Unable to post your inquiry";

                this.setState({
                    errorAlert: errorMessage,
                });

                // clear previous timer
                if (this.alertTimeout) {
                    clearTimeout(this.alertTimeout);
                }
            
                // start new timer
                this.alertTimeout = hideAlertAfterDelay(() => {
                    this.setState({ errorAlert: null });
                });
            });
    }

    render() {

        return (
            <>
                <React.Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Farmer's Fresh Meat - Testimonial</title>
                        <meta name="description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta name="robots" content="index, follow"/>
                        <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"/>
                        <meta property="og:type" content="article"/>
                        <meta property="og:title" content="Farmer's Fresh Meat - Voted Best Meat Market/Butcher Shop in Houston"/>
                        <meta property="og:description" content="Farmer's Fresh Meat is proud to be the best butcher shop and meat market in Houston, Texas. Buy wholesale beef, goat meat, chicken, and more - on sale now!"/>
                        <meta property="og:url" content={BASE_URL() + this.props.location.pathname}/>
                        <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop"/>
                        <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat"/>
                        <meta property="article:modified_time" content="2022-02-28T13:10:39+00:00"/>
                        <meta property="og:image" content={images.logoImg}/>
                        <meta property="og:image:width" content="1449"/>
                        <meta property="og:image:height" content="1024"/>
                        <meta name="twitter:card" content="summary"/>
                        <meta name="twitter:creator" content="Farmerfreshmeat"/>
                        <meta name="twitter:site" content="Farmerfreshmeat"/>
                        <link rel="canonical" href={BASE_URL() + this.props.location.pathname}/>
                        <script type="application/ld+json" className="yoast-schema-graph">{` {"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://farmersfreshmeat.com/#organization","name":"Farmer's Fresh Meat","url":"https://farmersfreshmeat.com/","sameAs":["https://www.facebook.com/farmersfreshmeat","https://www.instagram.com/farmersfreshmeat/","https://www.youtube.com/user/farmersfreshmeat","https://www.pinterest.com/Farmerfreshmeat/","https://twitter.com/Farmerfreshmeat"],"logo":{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/#logo","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2015/03/Farmers_Fresh_Meat_Logo.png","width":312,"height":79,"caption":"Farmer's Fresh Meat"},"image":{"@id":"https://farmersfreshmeat.com/#logo"}},{"@type":"WebSite","@id":"https://farmersfreshmeat.com/#website","url":"https://farmersfreshmeat.com/","name":"Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop","description":"Farmers Fresh Meat","publisher":{"@id":"https://farmersfreshmeat.com/#organization"},"potentialAction":[{"@type":"SearchAction","target":"https://farmersfreshmeat.com/?s={search_term_string}","query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"ImageObject","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage","inLanguage":"en-US","url":"https://farmersfreshmeat.com/wp-content/uploads/2019/09/Leg-Quarters-3-scaled.jpg","width":1449,"height":1024},{"@type":"WebPage","@id":"https://farmersfreshmeat.com/shop/leg-quarters/#webpage","url":"https://farmersfreshmeat.com/shop/leg-quarters/","name":"Fresh Chicken Leg Quarters By the Pound - On Sale now!","isPartOf":{"@id":"https://farmersfreshmeat.com/#website"},"primaryImageOfPage":{"@id":"https://farmersfreshmeat.com/shop/leg-quarters/#primaryimage"},"datePublished":"2019-09-23T15:14:32+00:00","dateModified":"2022-02-28T13:10:39+00:00","description":"Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer's Fresh Meat!","inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["https://farmersfreshmeat.com/shop/leg-quarters/"]}]}]}`}</script>
                    </Helmet>
                    <div className="about-banner mb-3">
                        <div className="image-wrap">
                            <div className="img-content">
                                <img
                                    src={images.about}
                                    alt="Not Found"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="overlay"></div>
                        </div>
                        <div className="banner-content">
                            <h1>Meet the Farmers</h1>
                            <h5>Your opinion.</h5>
                        </div>
                    </div>
                    <div className="container-fluid mb-fix emp-form">
                        <div className="col-12">
                            <div className="row">
                                <CommonStaticSidebar />
                                <div className="col-md-9">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-md-12 form-group">
                                            <div className="col-12 main-section bg-white px-3 py-4">
                                                {this.state.errorAlert ? (
                                                    <h6 className="success mb-2">{this.state.errorAlert}</h6>
                                                ) : null}
                                                <div className="row">
                                                    <div className="title pl-4 mb-0 text-center">
                                                        <h2 className="main-head">We value your feedback</h2>
                                                    </div>
                                                    <p className="text-center w-100 mb-3">Your email address will not be published. Required fields are marked *</p>
                                                    <div ref={this.messageRef} className="col-md-12 mb-3 fields px-3">
                                                        <label htmlFor="exampleInputFirstName" className="form-label">
                                                            Message *
                                                        </label>
                                                        <textarea
                                                            className={"form-control valid-control " + (this.state.errors.message ? " invalid" : "")}
                                                            name="message"
                                                            value={this.state.Data.message}
                                                            onChange={this.handleChange}
                                                            onBlur={this.handleBlur}
                                                        >
                                            </textarea>
                                                        <span className="error-text mt-1">
                                                {this.state.errors.message}
                                              </span>
                                                    </div>
                                                    <div ref={this.fullNameRef} className="col-md-4 mb-3 fields px-3">
                                                        <label
                                                            htmlFor="exampleInputFirstName"
                                                            className="form-label"
                                                        >
                                                            Full Name *
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={"form-control valid-control " + (this.state.errors.name ? " invalid" : "")}
                                                            name="name"
                                                            placeholder="Enter full name"
                                                            value={this.state.Data.name}
                                                            onChange={this.handleChange}
                                                            onBlur={this.handleBlur}
                                                            maxLength="50"
                                                        />
                                                        <span className="error-text mt-1">
                                                {this.state.errors.name}
                                              </span>
                                                    </div>
                                                    <div ref={this.emailRef} className="col-md-4 mb-3 fields px-3">
                                                        <label htmlFor="exampleInputFirstName" className="form-label">
                                                            Email *
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className={"form-control valid-control " + (this.state.errors.email ? " invalid" : "")}
                                                            placeholder="Email address"
                                                            name="email"
                                                            value={this.state.Data.email}
                                                            onChange={this.handleChange}
                                                            onBlur={this.handleBlur}
                                                        />
                                                        <span className="error-text mt-1">
                                                {this.state.errors.email}
                                              </span>
                                                    </div>
                                                    <div className="col-md-4 mb-3 fields px-3">
                                                        <label
                                                            htmlFor="exampleInputFirstName"
                                                            className="form-label"
                                                        >
                                                            Contact Number
                                                        </label>
                                                        <Input
                                                            international
                                                            withCountryCallingCode
                                                            maxLength="15"
                                                            country="US"
                                                            name="phone"
                                                            className="form-control"
                                                            placeholder="Enter phone number"
                                                            value={this.state.Data.phone}
                                                            onChange={this.handleEvenPhone}
                                                        />
                                                    </div>

                                                    <div className="col-md-12 fields px-4">
                                                        <button className="btn btn-order py-2 px-4"
                                                                onClick={(e) => this.handleSubmit(e)}>Post comment
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </>
        );
    }
}

export default Testimonial;
